export default __webpack_public_path__ + "static/media/bristi.f27651b6.png";